import { enableObservabilityConversationView } from '@gonfalon/dogfood-flags/dogfood-flags';

import { isLaunchDarklyMemberEmail } from './isLaunchDarklyMemberEmail';

/**
 * Show Vega ↔ observability conversation jump links only to LaunchDarkly staff,
 * and only when the destination conversation view itself is enabled.
 */
export function canShowVegaO11yConversationLinks(email: string | null | undefined): boolean {
  return isLaunchDarklyMemberEmail(email) && enableObservabilityConversationView();
}
